import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import "./styles/Status.css";

// metrics object elements:
// schedulePerformanceIndex
// costPerformanceIndex
// daysIn
// duration
// calcPctComplete
// actualPctComplete
// budgetHours
// earnedValue
// plannedValue
// actualHours

function StatusProjectHealth(props) {
  return props.metricType == "SPI" ? (
    <Box sx={{ textAlign: "center" }}>
      <Box className="statusTableTitle">Schedule Health (SPI)</Box>
      <Table className="statusTable">
        <TableBody>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              Days since project start
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.daysIn}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">Project duration</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.duration}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowSubtotal">
            <TableCell className="statusTableCell">
              {"Calculated percent complete ( " +
                props.metricsObject.daysIn +
                " / " +
                props.metricsObject.duration +
                " )"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.calcPctComplete}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">Budget hours</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.budgetHours}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              Actual Percent Complete
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.actualPctComplete}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowSubtotal">
            <TableCell className="statusTableCell">
              {"EV: Earned Value ( " +
                props.metricsObject.budgetHours +
                " * " +
                props.metricsObject.actualPctComplete +
                ")"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.earnedValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowSubtotal">
            <TableCell className="statusTableCell">
              {"PV: Planned Value ( " +
                props.metricsObject.budgetHours +
                " * " +
                props.metricsObject.calcPctComplete +
                ")"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.plannedValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowTotal">
            <TableCell className="statusTableCell">
              {"SPI: Schedule Performance Index ( " +
                props.metricsObject.earnedValue +
                " / " +
                props.metricsObject.plannedValue +
                ")"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.schedulePerformanceIndex}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  ) : (
    <Box sx={{ textAlign: "center" }}>
      <Box className="statusTableTitle">Budget Health (CPI - Hours)</Box>
      <Table className="statusTable">
        <TableBody>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">Budget hours</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.budgetHours}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              Actual Percent Complete
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.actualPctComplete}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowSubtotal">
            <TableCell className="statusTableCell">
              {"EV: Earned Value ( " +
                props.metricsObject.budgetHours +
                " * " +
                props.metricsObject.actualPctComplete +
                ")"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.earnedValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">Actual Hours</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.actualHours}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRowTotal">
            <TableCell className="statusTableCell">
              {"CPI-H: Cost Performance Index based on Hours ( " +
                props.metricsObject.earnedValue +
                " / " +
                props.metricsObject.actualHours +
                ")"}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.costPerformanceIndex}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}

export default StatusProjectHealth;

StatusProjectHealth.propTypes = {
  metricsObject: PropTypes.object,
  metricType: PropTypes.string,
};

/*
     <table className="statusTable">
        <tr className="statusTableRow">
          <td className="statusTableColumnHeader">Metric</td>
          <td className="statusTableColumnHeader">Value</td>
        </tr>
        <tr className="statusTableRow">
          <td className="statusTableCell">
            Actual {props.metricsObject.suffix}
          </td>
          <td className="statusTableCell">{props.metricsObject.actualValue}</td>
        </tr>
      </table>
      */
